import { Component, OnInit, Input, Inject, forwardRef } from '@angular/core';

import { GraphTreeComponent } from '../graph-tree.component';
import { GraphNode } from '../type';

@Component({
    selector: 'app-graph-node',
    templateUrl: './graph-node.component.html',
    styleUrls: ['./graph-node.component.scss'],
})
export class GraphNodeComponent implements OnInit {
    @Input() node: GraphNode;

    hover = false;

    constructor(
        @Inject(forwardRef(() => GraphTreeComponent)) public tree: GraphTreeComponent,
    ) { }

    ngOnInit(): void {}

    onClick(e): void {
        e.stopPropagation();
        this.tree.selectNode(this.node);
    }

    onMouseOver(e): void {
        e.stopPropagation();
        this.hover = true;
    }

    onMouseOut(): void {
        this.hover = false;
    }
}
